import { render, staticRenderFns } from "./profile-membership.vue?vue&type=template&id=651811f6&scoped=true"
import script from "./profile-membership.vue?vue&type=script&lang=js"
export * from "./profile-membership.vue?vue&type=script&lang=js"
import style0 from "./profile-membership.vue?vue&type=style&index=0&id=651811f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651811f6",
  null
  
)

export default component.exports